import { formatBasicInfo } from './format-basic-info';
import { formatCurrentAddress } from './format-current-address';

import { PersonDataRequest, PersonData } from '../../model';

type PersonFormatter = (personData: PersonData) => Partial<PersonDataRequest>;

function createPersonFormatter(
  formatter: (personData: PersonData) => Partial<PersonDataRequest>
): PersonFormatter {
  return (personData: PersonData) => formatter(personData);
}

const personFormatters = {
  basicInfo: createPersonFormatter((personData) => {
    return personData.basicInfo ? formatBasicInfo(personData.basicInfo) : {};
  }),
  currentAddress: createPersonFormatter((personData) => {
    return personData.currentAddress
      ? formatCurrentAddress(personData.currentAddress)
      : {};
  }),
};

export function formatPersonValues(
  values: Partial<PersonData>
): PersonDataRequest {
  if (!values.basicInfo) {
    throw new Error('basicInfo is required to format person values');
  }

  return Object.values(personFormatters).reduce<PersonDataRequest>(
    (acc, formatter) => ({ ...acc, ...formatter(values) }),
    {} as PersonDataRequest
  );
}
